import { useEffect, useState } from "react";
import { getHotels } from "../services/API";
import CardLayout2 from "./CardLayout2";
import type { cards } from "../Types";

const HotelsContainer: React.FC<cards>= ({title}) => {
    
    const [hotels, setHotels] = useState([]);

    const initData = async () => {
        const data = await getHotels()
        if (data) {
            setHotels(data)
        }
    }

    useEffect(() => {
        initData()
    }
    ,[])

    return (
        <>
        { hotels.length ? 
            <section className="app-section container-fluid pt-0">
                <div className="container pb-5 pb-md-5 pb-lg-2">

                    <div className="row pb-4 pb-md-5 mt-5">
                        <h2 className="fw-bold fs-4 fs-md-4 col">{title}</h2>
                    </div>

                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">

                        {hotels.slice(0, 6).map((hotel: any) => {
                            return (
                                <div className="col" key={hotel.entryId ?? hotel.DocumentLink}>
                                    <CardLayout2
                                        image={hotel.DDImage}
                                        title={hotel.name}
                                        classification={hotel.classification}
                                        region={hotel.region}
                                        introduction={hotel.description}
                                        href={hotel.DocumentLink}
                                    />
                                </div>
                            )
                        })}
                        
                    </div>
                </div>
            </section> 
        : " "}
        </>
    )
}

export default HotelsContainer